module.exports = __webpack_public_path__ + "img/20191012161445093.e871a9e5.jpg";